import React from 'react'
import styles from './List.module.css'
import arrowUpRight from '../../../assets/images/arrow-up-right.png'
import { Link } from 'react-router-dom'

const List = (props: any) => {

    const list = props.data && props.data.length && props.data.map((item: any) => {
        return  <li className={`${styles.listItem} py-4`} key={item.id}>
                    <span className="text-capitalize">{item.type}</span>
                    <span>{item.dateTaken}</span>
                    <span>{item.csat}%</span>
                    <span>{item.qaScore}%</span>
                    <span className={`${styles.rating}`}>
                        <i className="bi bi-star-fill"></i>{item.nytroRating}
                    </span>
                    <span>{item.actionsPending}</span>
                    <span>{item.comments}</span>
                    <span>
                        <Link to={`${item.uuid}`}>
                            <img src={arrowUpRight} alt="Link" width="18px" />
                        </Link>
                    </span>
                </li>
    })
        

    return (
        <ul className={`${styles.listContainer} p-0 list-unstyled mx-4`}>
           {list} 
        </ul>
    )
}

export default List
